import { render } from "./ReportHistorySensor.vue?vue&type=template&id=fe7ba214"
import script from "./ReportHistorySensor.vue?vue&type=script&lang=js"
export * from "./ReportHistorySensor.vue?vue&type=script&lang=js"
script.render = render

export default script